<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.category') }}
          b-form-select.text-uppercase(v-model="providerCatSelected" @change="getProviderList()" :disabled="loading" size="sm")
            template(v-for="cat in providerCategoryList")
              option(v-if="cat == null" :value="null") {{ $t('ui.all') }}
              option(v-else :value="cat") {{ cat }}

      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getProviderList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12.mb-1
        div {{ $t('message.actionPerformWillReflectProd') }}
  .card-body
    .row
      .col-12 
        .clusterize-scroll
          .table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center.sticky-position(width="4%")
                    span #
                  th.sticky-position(width="10%")
                    span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                  th.sticky-position(width="20%")
                    span(:title="$t('ui.provider_name')") {{ $t("ui.provider_name") }}
                  th.sticky-position(width="18%")
                    span(:title="$t('ui.category')") {{ $t("ui.category") }}
                  th.sticky-position.text-center(width="7%")
                    span(:title="$t('ui.status')") {{ $t("ui.status") }}
                  th.sticky-position.text-center(width="10%")
                    span {{ $t('ui.sequence') }}
                  th.sticky-position.text-center(width="20%" v-if="isProviderGameAccess || isProviderHotGameAccess")
                    span {{ $t('ui.action') }}
              tbody
                tr(v-if="providerList.length == 0")
                  td(colspan="7").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in providerList")
                  td.text-center
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    span(:title="item.provider_code") {{ item.provider_code }}
                  td
                    span(:title="item.provider_name") {{ item.provider_name }}
                  td
                    span(:title="item.category") {{ item.category }}
                  td.text-center
                    div.d-flex.justify-content-center.align-items-center
                      label.custom-switch
                        input.custom-switch-input.position-relative(type='checkbox' name='custom-switch-checkbox' v-model="item.status" :disabled="!isEditAccess" @change="!isEditAccess ? null : changedStatus(item, $event)")
                        span.custom-switch-indicator
                  td
                    b-form-select.text-center(v-model="item.seq" :disabled="!isEditAccess" @change="!isEditAccess ? null : changedSeq(item, $event)" size="sm")
                      option(value=0 disabled) 0
                      option(v-for="index in providerListLength" :key="index") {{ index }}
                      option(v-if="providerListLength < 100" :key="100") 100
                  td.text-center(v-if="isProviderGameAccess || isProviderHotGameAccess || isProviderNewGameAccess || isProviderPopularGameAccess || isProviderFeaturedGameAccess")
                    .d-inline-block.mx-1.my-1(v-if="isProviderGameAccess")
                      a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                        href="javascript:void(0)"
                        @click="onUpdate(item)"
                        :title="$t('ui.update')"
                        )
                    .d-inline-block.mx-1.my-1(v-if="isProviderHotGameAccess")
                      a.fas.fa-fire.btn.btn-ssm.btn-icon.btn-danger(
                        href="javascript:void(0)"
                        @click="onUpdateHotGame(item)"
                        :title="$t('ui.hot_game')"
                        )
                    .d-inline-block.mx-1.my-1(v-if="isProviderNewGameAccess")
                      a.fas.fa-crown.btn.btn-ssm.btn-icon.btn-success(
                        href="javascript:void(0)"
                        @click="onUpdateNewGame(item)"
                        :title="$t('ui.new_game')"
                        )
                    .d-inline-block.mx-1.my-1(v-if="isProviderFeaturedGameAccess")
                      a.fas.fa-ribbon.btn.btn-ssm.btn-icon.btn-info(
                        href="javascript:void(0)"
                        @click="onUpdateFeaturedGame(item)"
                        :title="$t('ui.featured_game')"
                        )
                    .d-inline-block.mx-1.my-1(v-if="isProviderPopularGameAccess")
                      a.fas.fa-star.btn.btn-ssm.btn-icon.btn-warning(
                        href="javascript:void(0)"
                        @click="onUpdatePopularGame(item)"
                        :title="$t('ui.popular_game')"
                        )

      editprovidergameoff(ref="editprovidergameoff" :item="editSelectedProvider" @clicked="afterUpdate" @failed="handleFailed")
      editproviderhotgame(ref="editproviderhotgame" :item="editSelectedProvider" @clicked="afterUpdateHotGame" @failed="handleFailed")
      editprovidernewgame(ref="editprovidernewgame" :item="editSelectedProvider" @clicked="afterUpdateNewGame" @failed="handleFailed")
      editproviderpopulargame(ref="editproviderpopulargame" :item="editSelectedProvider" @clicked="afterUpdatePopularGame" @failed="handleFailed")
      editproviderfeaturedgame(ref="editproviderfeaturedgame" :item="editSelectedProvider" @clicked="afterUpdateFeaturedGame" @failed="handleFailed")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import { DraggableTree } from "vue-draggable-nested-tree";
import * as th from 'tree-helper'
import editprovidergameoff from "@/components/setup/editProviderGameOff.vue";
import editproviderhotgame from "@/components/setup/editProviderHotGame.vue";
import editprovidernewgame from "@/components/setup/editProviderNewGame.vue";
import editproviderpopulargame from "@/components/setup/editProviderPopularGame.vue";
import editproviderfeaturedgame from "@/components/setup/editProviderFeaturedGame.vue";

export default {
  components: {
    SubmitButton,
    Tree: DraggableTree,
    editprovidergameoff,
    editproviderhotgame,
    editprovidernewgame,
    editproviderpopulargame,
    editproviderfeaturedgame
  },
  props: {
    siteId: {
      type: Number
    },
    siteInfo: {
      type: Array
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      providerCategoryList: [
        null,
        "SLOTS",
        "LIVECASINO",
        "SPORTSBOOK",
        "COCKFIGHT",
        "OTHERS",
      ],
      providerCatSelected: null,
      providerList: [],
      editSelectedProvider: null,
      maxSeq: 0
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_provideroperator");
    },
    isProviderGameAccess() {
      return this.$helpers.showActionButton("providergameoff");
    },
    isProviderHotGameAccess() {
      return this.$helpers.showActionButton("providerhotgame");
    },
    isProviderNewGameAccess() {
      return this.$helpers.showActionButton("providernewgame");
    },
    isProviderPopularGameAccess() {
      return this.$helpers.showActionButton("providerpopulargame");
    },
    isProviderFeaturedGameAccess() {
      return this.$helpers.showActionButton("providerfeaturedgame");
    },
    providerListLength() {
      if (this.providerList) {
        if(this.maxSeq > this.providerList.length) {
          return this.maxSeq;
        } else {
          return this.providerList.length;
        }
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.getProviderList();
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        category: this.providerCatSelected,
        operator_id: this.operatorID,
        is_free: false,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.providerList = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                if(this.providerList.length > 0) {
                  // Filter out objects with seq < 100, then find the max seq value
                  const maxSeq = this.providerList
                      .filter(item => item.seq < 100) // Keep only items with seq < 100
                      .reduce((max, item) => Math.max(max, item.seq), -Infinity); // Find the maximum seq

                  this.maxSeq = maxSeq;
                } else {
                  this.maxSeq = 0;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_provider_status_confirm", { provider: item.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.provideOperatorStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: item.provider_code,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getProviderList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedSeq: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_provider_seq_confirm", { provider: item.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmSeq(item, eventStatus);
          } else {
            this.getProviderList();
          }
        });
    },
    confirmSeq: function(item, seq) {
      let url = config.providerOperatorUpdateSeqUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: item.provider_code,
        seq: seq
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getProviderList();
              }
            }
          } catch (error) {
            this.getProviderList();
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.getProviderList();
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
     onUpdate(item) {
      this.editSelectedProvider = item;
      this.$refs.editprovidergameoff.$refs.editProviderGameOff.show();
    },
    onUpdateHotGame(item) {
      this.editSelectedProvider = item;
      this.$refs.editproviderhotgame.$refs.editProviderHotGame.show();
    },
    onUpdateNewGame(item) {
      this.editSelectedProvider = item;
      this.$refs.editprovidernewgame.$refs.editProviderNewGame.show();
    },
    onUpdatePopularGame(item) {
      this.editSelectedProvider = item;
      this.$refs.editproviderpopulargame.$refs.editProviderPopularGame.show();
    },
    onUpdateFeaturedGame(item) {
      this.editSelectedProvider = item;
      this.$refs.editproviderfeaturedgame.$refs.editProviderFeaturedGame.show();
    },
    afterUpdate: function(item) {
      this.$helpers.showDialog(this.$t("ui.combine.edit_provider_game_off"), this.$t("message.success"), "success");
    },
    afterUpdateHotGame: function(item) {
      this.$helpers.showDialog(this.$t("ui.combine.edit_provider_hot_game"), this.$t("message.success"), "success");
    },
    afterUpdateNewGame: function(item) {
      this.$helpers.showDialog(this.$t("ui.combine.edit_provider_new_game"), this.$t("message.success"), "success");
    },
    afterUpdatePopularGame: function(item) {
      this.$helpers.showDialog(this.$t("ui.combine.edit_provider_popular_game"), this.$t("message.success"), "success");
    },
    afterUpdateFeaturedGame: function(item) {
      this.$helpers.showDialog(this.$t("ui.combine.edit_provider_featured_game"), this.$t("message.success"), "success");
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    }
  }
};
</script>